import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { IResponse } from 'src/app/shared/models/app';
import { CacheResolverService } from '../cache/cache-resolver.service';
import { CacheConstant } from '../cache/cache.constant';
import {  CacheDuration } from '../constants/app.constant';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class PreferenceService extends BaseService {
  preferences$: Subject<any> = new Subject<any>();
  constructor(protected http: HttpClient, private cache:CacheResolverService) { 
    super(http);
  } 

  setPreferences(prefs: any){
    this.cache.set(
      CacheConstant.LocalStorage.Preferences,
      prefs,
      CacheDuration.OneDay
    );
  }

  getPreference(id: any) {
    let departmentPreferences = this.cache.get(
      CacheConstant.LocalStorage.Preferences
    );
    return departmentPreferences ? departmentPreferences[id] : null;
  }
  getsPreference() {
    let departmentPreferences = this.cache.get(
      CacheConstant.LocalStorage.Preferences
    );
    return departmentPreferences ;
  }
 
}
